import React, { useState } from 'react';

import { TransactionList as TransactionListPackage } from '@eika/transaction-list';

import {
    CreditCardMovement,
    TransactionsService,
    useCreditCardReservationsByAccount,
    useCreditCardTransactionsByAccount,
} from '@/domain/account';

import TransactionListSkeleton from '@components/skeleton/TransactionListSkeleton';
import useText from '@hooks/use-text';

import { Status } from './Status';
import TransactionDetailModal from './TransactionDetailModal';

export const TransactionsList = () => {
    const text = useText();

    const transactionsQuery = useCreditCardTransactionsByAccount();
    const reservationsQuery = useCreditCardReservationsByAccount();

    const [selectedTransaction, setSelectedTransaction] = useState<CreditCardMovement>();

    if (transactionsQuery.isError || reservationsQuery.isError) {
        return (
            <div className="transaction-list-with-status">
                <Status />
            </div>
        );
    }

    if (transactionsQuery.isPending || reservationsQuery.isPending) {
        return <TransactionListSkeleton />;
    }
    const transactions = [...reservationsQuery.data, ...transactionsQuery.data.pages.flatMap((item) => item.elements)];

    const onClickTransaction = (transactionId: string) => {
        const transaction = transactions.find((t) => t.id === transactionId);
        if (transaction) {
            setSelectedTransaction(transaction);
        }
    };

    const onClose = () => {
        setSelectedTransaction(undefined);
    };

    return (
        <>
            <div className="transaction-list-with-status">
                <div className="transaction-list-with-status__transactions">
                    <TransactionListPackage
                        reservedText={text.transactionsReserved}
                        transactions={TransactionsService.toTransactionListSections(transactions, onClickTransaction)}
                    />
                </div>
                <Status />
            </div>
            <TransactionDetailModal onClose={onClose} transaction={selectedTransaction} />
        </>
    );
};
